import { z } from "zod";
import {
  MunicipalitiesEnum,
  PlanningProposalsFilterPropertyTypesItem,
  RegionsEnum,
  PlanningProposalsFilterStatusItem,
} from "~/api/generated/model";

export const proposalSearchSchema = z.object({
  page: z.number().nonnegative().optional(),
  // Bookmarks from before areas were codes carry name keys; drop them instead of failing the route.
  regions: z.array(z.enum(RegionsEnum)).optional().catch(undefined),
  municipalities: z
    .array(z.enum(MunicipalitiesEnum))
    .optional()
    .catch(undefined),
  status: z.array(z.enum(PlanningProposalsFilterStatusItem)).optional(),
  propertyTypes: z
    .array(z.enum(PlanningProposalsFilterPropertyTypesItem))
    .optional(),
  builderOrDeveloper: z.boolean().optional(),
  preciseLocation: z.boolean().optional(),
});

export type ProposalSearch = z.infer<typeof proposalSearchSchema>;

export type AgentFilter = Omit<ProposalSearch, "page">;
